'use client'

import React, { useState } from 'react';
import { PlayOutcome } from '../common/logic';
import { round } from '../common/math';

interface GameOver {
	mode: string;
	username: string;
	outcome: PlayOutcome;
	onRestart: () => void;
}

export default function GameOver({mode, username, outcome, onRestart}: GameOver) {
	if (mode != "gameover")
		return <></>;

	const cards = outcome.play.cards;
	const players = outcome.play.players;
	const winner = outcome.winner;

	const outcomeName = outcome.showdown ? "showdown" : "split";
	const header = (
		<tr>
			<th> Player </th>
			<th> Hand </th>
			<th> (*) </th>
			<th> { outcome.showdown ? "Prize" : "Split" } </th>
		</tr>
	);
	const scores = cards.hands.map((hand: number, i: number) =>
		<tr key={i}>
			<td className="text">
				{players[i]}
				{(players[i] == winner) ? '✓' : ''}
			</td>
			<td className="number"> {round(hand * 1000)} </td>
			<td className="number"> ({round(cards.handicap * hand * 1000)}) </td>
			<td className="number"> {round(outcome.prizes[i], 4)} </td>
		</tr>
	);

	return (
	<div>
		<header>
			<h2>Game over</h2>
			<button onClick={onRestart}>↺ Play again</button>
		</header>
		<main>
			<p>
			The game ended in a {outcomeName}.
			The community card was {round(cards.handicap * 100, 2)}%.
			</p>
			<div className="table-container">
			<table className="scoreboard">
			{header}
			{scores}
			</table>
			</div>
		</main>
	</div>
	);
}

